import { Routes } from '@angular/router';
import { authGuard, guestGuard, moduleGuard } from './auth/auth.guard';
import { unsavedChangesGuard } from './auth/unsaved-changes.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout';
import { MainLayoutComponent } from './layouts/main-layout/main-layout';
import { LoginComponent } from './pages/login/login';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { IncidentFeedComponent } from './pages/incident-feed/incident-feed';
import { IncidentDetailComponent } from './pages/incident-detail/incident-detail';
import { PersonsComponent } from './pages/persons/persons';
import { ConfigurationComponent } from './pages/configuration/configuration';
import { ProgramsComponent } from './pages/configuration/programs/programs';
import { CategoriesComponent } from './pages/configuration/categories/categories';
import { TaxonomyDetailComponent } from './pages/configuration/categories/taxonomy-detail/taxonomy-detail';
import { DataElementsComponent } from './pages/configuration/data-elements/data-elements';
import { RollupTaxonomiesComponent } from './pages/configuration/rollup-taxonomies/rollup-taxonomies';
import { RollupDetailComponent } from './pages/configuration/rollup-detail/rollup-detail';
import { InvestigationFeedComponent } from './pages/investigation-feed/investigation-feed';
import { InvestigationDetailComponent } from './pages/investigation-detail/investigation-detail';
import { SearchComponent } from './pages/search/search';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
      { path: 'auth/callback', component: AuthCallbackComponent },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'incidents', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'incidents', component: IncidentFeedComponent },
      { path: 'persons', component: PersonsComponent, canActivate: [moduleGuard('Persons')] },
      {
        path: 'investigations',
        component: InvestigationFeedComponent,
        canActivate: [moduleGuard('Investigations')],
      },
      {
        path: 'investigations/:id',
        component: InvestigationDetailComponent,
        canActivate: [moduleGuard('Investigations')],
      },
      {
        path: 'incidents/:id',
        component: IncidentDetailComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'search',
        component: SearchComponent,
        canActivate: [moduleGuard('Search')],
      },
      {
        path: 'configuration',
        component: ConfigurationComponent,
        children: [
          { path: '', redirectTo: 'programs', pathMatch: 'full' },
          { path: 'programs', component: ProgramsComponent },
          { path: 'categories', component: CategoriesComponent },
          { path: 'taxonomy/:type/:id', component: TaxonomyDetailComponent },
          { path: 'data-elements', component: DataElementsComponent },
          { path: 'rollup-taxonomies', component: RollupTaxonomiesComponent },
          { path: 'rollup/:type/:id', component: RollupDetailComponent },
        ],
      },
    ],
  },
  { path: '**', redirectTo: 'incidents' },
];
